import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { IAccountSidebarBaseData } from '~interfaces/IAnalytics';

export class AccountLoyaltyPointsInfoUseCase {
    private eventRepository: EventRepository;
    private accountLoyaltyPointsInfoData: IAccountSidebarBaseData;

    constructor(accountLoyaltyPointsInfoData: IAccountSidebarBaseData) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.accountLoyaltyPointsInfoData = accountLoyaltyPointsInfoData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.accountLoyaltyPointsInfoData.eventAction,
            type: 'link',
            payload: this.getAccountLoyaltyPointsInfoPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getAccountLoyaltyPointsInfoPayload() {
        const { eventAction, label } = this.accountLoyaltyPointsInfoData;

        return {
            event_name: 'my account page',
            event_category: 'my account page',
            event_action: eventAction,
            event_label: label,
            site_type: 'event_based'
        };
    }
}
